import React, {Component} from "react";

class ResultSignatureArea extends Component {

    render() {
        const {class_info} = this.props;

        return (
            <div style={{display: "flex", flexDirection: "row", placeItems: "center", marginTop: "150px"}}>
                <div className="print-identity-card print-signature-area">
                    <div className="wrapper" style={{width: "60%"}}>
                        <hr style={{marginBottom: "15px"}}/>
                        <h3>{"ریس"} {class_info?.faculty} </h3>
                    </div>
                </div>
                <div className="print-identity-card print-signature-area">
                    <div className="wrapper" style={{width: "60%"}}>
                        <hr style={{marginBottom: "15px"}}/>
                        <h3>{"آمر دیپارتمنت"} {class_info?.faculty}</h3>
                    </div>
                </div>
                <div className="print-identity-card print-signature-area">
                    <div className="wrapper" style={{width: "60%"}}>
                        <hr style={{marginBottom: "15px"}}/>
                        <h3>{"مدیرتدریسی"} {class_info?.faculty} </h3>
                    </div>
                </div>
            </div>

        );
    }
}

export default ResultSignatureArea;
